import { styled } from 'baseui'
import { lightTheme } from '@/customTheme'

const OuterRing = styled('div', {
  position: 'absolute',
  inset: 0,
  borderRadius: '8px',
  border: `2px solid ${lightTheme.colors.pink}`,
  pointerEvents: 'none',
})

const InnerRing = styled('div', {
  position: 'absolute',
  inset: '2px',
  borderRadius: '6px',
  border: `2px solid ${lightTheme.colors.white}`,
  pointerEvents: 'none',
})

/**
 * Active-tile double ring shared by the thumbnail grids: 2px pink outer, 2px
 * white inner, on an 8px-radius tile.
 *
 * Elements rather than an inset box-shadow on the tile itself: inset shadows
 * paint below children, so a tile's scrim would cover the ring. Mount it AFTER
 * any scrim.
 */
function SelectionOutline({ active, shape = 'rounded' }: { active: boolean; shape?: 'rounded' | 'circle' }) {
  if (!active) return null
  return (
    <>
      <OuterRing $style={shape === 'circle' ? { borderRadius: '50%' } : undefined} />
      <InnerRing $style={shape === 'circle' ? { borderRadius: '50%' } : undefined} />
    </>
  )
}

export default SelectionOutline
